import React from "react";
import {Col, FormGroup, Row} from "reactstrap";
import {useSelector} from "react-redux";
import {getSimUsageDetails} from "../../../../redux/Selectors/sim.selector";

function SimUsageInformation(_props, ref) {
  const simUsageDetails = useSelector(getSimUsageDetails);
  const simUsageData = simUsageDetails ? simUsageDetails : {};

  React.useImperativeHandle(ref, () => {
    return {
      state: {},
    };
  });
  const {ctdDataUsage, ctdSMSUsage, ctdVoiceUsage, ctdSessionCount} = simUsageData;
  return (
    <div className="pl-lg-4">
      <ul>
        <Row>
          <Col md="12">
            <li>
              <FormGroup>
                <label className="form-control-label" htmlFor="input-name">
                  DATA:
                </label>
                <label
                  className="form-control-label sim-usage-label-value"
                  htmlFor="input-name"
                >
                  {ctdDataUsage ? ctdDataUsage : "NA"}
                </label>
              </FormGroup>
            </li>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <li>
              <FormGroup>
                <label className="form-control-label" htmlFor="input-name">
                  SMS:
                </label>
                <label
                  className="form-control-label sim-usage-label-value"
                  htmlFor="input-name"
                >
                  {ctdSMSUsage ? ctdSMSUsage : "NA"}
                </label>
              </FormGroup>
            </li>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <li>
              <FormGroup>
                <label className="form-control-label" htmlFor="input-name">
                  VOICE:
                </label>
                <label
                  className="form-control-label sim-usage-label-value"
                  htmlFor="input-name"
                >
                  {ctdVoiceUsage ? ctdVoiceUsage : "NA"}
                </label>
              </FormGroup>
            </li>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <li>
              <FormGroup>
                <label className="form-control-label" htmlFor="input-name">
                  SESSION:
                </label>
                <label
                  className="form-control-label sim-usage-label-value"
                  htmlFor="input-name"
                >
                  {ctdSessionCount ? ctdSessionCount : "NA"}
                </label>
              </FormGroup>
            </li>
          </Col>
        </Row>
      </ul>
    </div>
  );
}

export default React.forwardRef(SimUsageInformation);
